import { RouterModule, Routes } from "@angular/router"; 
import { ReunioesListComponent } from "./components/reunioes-list/reunioes-list.component";
import { PautaEditComponent } from "./components/pauta-edit/pauta-edit.component";
import { ItensEditComponent } from "./components/itens-edit/itens-edit.component";
import { OrdemEditComponent } from "./components/ordem-edit/ordem-edit.component";
import { AnexosListComponent } from "./components/anexos-list/anexos-list.component";
import { ParticipantesListComponent } from "./components/participantes-list/participantes-list.component";
import { NavTabsComponent } from "./components/nav-tabs/nav-tabs.component";
import { DirtycheckGuard } from "./dirtycheck.guard";
import { ApresentacaoPautaComponent } from "./components/apresentacao-pauta/apresentacao-pauta.component";
import { NavTabsApresentacaoComponent } from "./components/nav-tabs-apresentacao/nav-tabs-apresentacao.component";
import { ApresentacaoQuadroGeralComponent } from "./components/apresentacao-quadro-geral/apresentacao-quadro-geral.component";
import { ApresentacaoProjetosComponent } from "./components/apresentacao-projetos/apresentacao-projetos.component";
import { ApresentacaoSlideComponent } from "./components/apresentacao-slide/apresentacao-slide.component";
import { ApresentacaoRegistroComponent } from "./components/apresentacao-registro/apresentacao-registro.component";
import { ApresentacaoDemandasComponent } from "./components/apresentacao-demandas/apresentacao-demandas.component";
import { ApresentacaoAnexosComponent } from "./components/apresentacao-anexos/apresentacao-anexos.component";
import { AdminListComponent } from "./components/admin-list/admin-list.component";
  
const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: 'admin',
                component: AdminListComponent
            },
            {
                path: 'reunioes',
                children: [
                    {
                        path: '',
                        component: ReunioesListComponent
                    },
                    {
                        path: 'apresentacao/:id',
                        component: NavTabsApresentacaoComponent,
                        children: [
                            { path: '', redirectTo: 'pauta', pathMatch: "full" },
                            {
                                path: 'pauta',
                                component: ApresentacaoPautaComponent
                            },
                            {
                                path: 'quadro-geral',
                                component: ApresentacaoQuadroGeralComponent
                            },
                            {
                                path: 'projetos',
                                component: ApresentacaoProjetosComponent
                            },
                            {
                                path: 'indicador',
                                component: ApresentacaoSlideComponent
                            },
                            {
                                path: 'registro',
                                component: ApresentacaoRegistroComponent
                            },
                            {
                                path: 'demandas',
                                component: ApresentacaoDemandasComponent
                            },
                            {
                                path: 'anexos',
                                component: ApresentacaoAnexosComponent
                            },
                            {
                                path: 'participantes',
                                component: ParticipantesListComponent,
                                canDeactivate: [DirtycheckGuard]
                            },
                        ]
                        
                    },
                    {
                        path: ':type/:id',
                        component: NavTabsComponent,
                        children: [
                            { path: '', redirectTo: 'pauta', pathMatch: "full" },
                            {
                                path: 'pauta',
                                component: PautaEditComponent,
                                canDeactivate: [DirtycheckGuard]
                            },
                            {
                                path: 'itens',
                                component: ItensEditComponent,
                                canDeactivate: [DirtycheckGuard]
                            },
                            {
                                path: 'ordem',
                                component: OrdemEditComponent,
                                canDeactivate: [DirtycheckGuard]
                            },
                            {
                                path: 'anexos',
                                component: AnexosListComponent
                            },
                            {
                                path: 'participantes',
                                component: ParticipantesListComponent,
                                canDeactivate: [DirtycheckGuard]
                            },
                        ]
                    }
                ]            
            }
        ]
    }
];

export const ReuniaoRoutes = RouterModule.forChild(routes);